import React from 'react';
import IconPattern, { IconProps } from './_IconPattern';

const GooglePlayIconSVG: React.FunctionComponent<{ width?: number; height?: number }> = ({
  width = 24,
  height = 24,
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path
      d="M3.609 1.814L13.792 12L3.609 22.186C3.233 21.847 3 21.349 3 20.798V3.202C3 2.651 3.233 2.153 3.609 1.814Z"
      fill="#00D6FD"
    />
    <path
      d="M17.541 8.251L13.792 12L17.541 15.749L22.155 13.089C22.901 12.665 22.901 11.335 22.155 10.911L17.541 8.251Z"
      fill="#FFDA03"
    />
    <path d="M3.609 1.814L13.792 12L17.541 8.251L5.215 1.15C4.641 0.82 3.993 0.914 3.609 1.814Z" fill="#00EE76" />
    <path d="M13.792 12L3.609 22.186C3.993 23.086 4.641 23.18 5.215 22.85L17.541 15.749L13.792 12Z" fill="#FF3A44" />
  </svg>
);

const GooglePlayIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={GooglePlayIconSVG} variantPlaces={[]} {...props} />;
};

export default GooglePlayIcon;
